import ExcludeBattleModal from './ExcludeBattleModal';

export default ExcludeBattleModal;
